const debug = true;
const color = 'rgb(255,75,75)';
const markColor = "rgba(255,75,75,0.45)";
const markSubColor = "rgba(255,75,75,0.2)";
const markGridX = 20;
const markGridY = 20;
const mountainWidth = markGridX;
const mountainOffset = markGridX;
const mountainHeight = markGridY * 2;
const stepSize = 1;
const pointAspectRatio = 1.145;
const mVRatio = markGridY / 0.5; // (1 mark = 0.5mV)
const xRatio = ( markGridX * 5 ) / 160; // point in sec / hz (1 mark = 200ms)

class ECGChart {

    mountainArray = [{ x: 0, y: 0}, { x: mountainOffset, y: 0}, { x: mountainOffset, y: mountainHeight}, { x: mountainOffset + mountainWidth, y: mountainHeight}, { x: mountainOffset + mountainWidth, y: 0}, { x: (2*mountainOffset)+mountainWidth, y: 0}];
    minY = -1.6 * markGridY;
    maxY = 31.6 * markGridY;
    delayBetweenPoints = 0;

    constructor(el, data = {}) {
        this.el = document.getElementById(el);
        this.container = document.createElement("div");
        this.container.className = "chart-container";
        this.canvas = document.createElement("canvas");
        this.canvas.id = el+'_canvas';
        this.canvas.height = (this.maxY - this.minY) * (pointAspectRatio - 0.06);
        this.canvas.style.backgroundColor = 'rgba(255,255,255,1)';

        this.el.appendChild(this.container);
        this.container.appendChild(this.canvas);

        // this.initialMax = parseInt($(this.container).width()/pointAspectRatio);
        this.initialMax = $(this.container).width()/pointAspectRatio;
        
        if(this.initialMax < data.dataD1.length * xRatio + (mountainOffset * 2 + mountainWidth)) {
            this.initialMax = data.dataD1.length * xRatio + (mountainOffset * 2 + mountainWidth);

            let width = this.initialMax * pointAspectRatio;

            this.canvas.width = width;
            $(this.canvas).css('width', width);
            $(this.container).css('width', width);
            // this.resizeContainer(data.dataD1);
            this.scrollContainer(data.dataD1.length * 0.5);
        } else {
            let width = this.initialMax * pointAspectRatio;

            this.canvas.width = width;
            // $(this.canvas).css('width', width);
        }

        const convertedData = this.convertData(data, 'dataD1');
        const last = convertedData[convertedData.length - 1];

        if (this.initialMax < last.x) {
            this.initialMax = last.x;
        }

        this.chart = new Chart(this.canvas.id, {
            type: 'line',
            data: {
                // labels: [''],
                datasets: [{
                    label: 'dataD1',
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: convertedData,
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                },{
                    label: 'dataD2',
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: this.convertData(data, 'dataD2'),
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                },{
                    label: 'dataD3',
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: this.convertData(data, 'dataD3'),
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                },{
                    label: 'dataAVR',
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: this.convertData(data, 'dataAVR'),
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                },{
                    label: 'dataAVL',
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: this.convertData(data, 'dataAVL'),
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                },{
                    label: 'dataAVF',
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: this.convertData(data, 'dataAVF'),
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                },{
                    label: 'dataV2',
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: this.convertData(data, 'dataV2'),
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                },{
                    label: 'dataV5',
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: this.convertData(data, 'dataV5'),
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                }]
            },
            options: {
                layout: {
                    padding: {
                        left: -10,
                        bottom: -10
                    }
                },
                animation: false,
                interaction: {
                    intersect: false
                },
                plugins: {
                    legend: false,
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            title: function(tooltipItem) {
                                return '';
                            },
                            label: (context) => {
                                var label = context.dataset.label || '';

                                const baseY = this.getBaseYByType(label);

                                if (label) {
                                    label += ': ';
                                }

                                if (context.parsed.y !== null) {
                                    label += (context.parsed.y - baseY) / mVRatio;
                                }

                                return label;
                            }
                        }
                    },
                    whiteBackground: true
                },
                scales: {
                    x: {
                        type: 'linear',
                        min: 0,
                        // max: data.length < 100 ? 100 : data.length,
                        max: this.initialMax,
                        grid: {
                            color: function(line) {
                                if(line.tick.value % markGridX == 0) {
                                    // console.info('mark line', line);
                                    // return "rgba(0,0,0)";
                                    return markColor;
                                }
                                else if(line.tick.value % (markGridX / 5) == 0) {
                                    return markSubColor;
                                }

                                return false;
                            }
                        },
                        ticks: {
                            display: false,
                            stepSize: stepSize,
                        },
                    },
                    y: {
                        min: this.minY,
                        max: this.maxY,
                        type: 'linear',
                        grid: {
                            color: function(line) {
                                if(line.tick.value % markGridY == 0) {
                                    // console.info('mark line', line);
                                    // return "rgba(0,0,0)";
                                    return markColor;
                                } else if(line.tick.value % (markGridY / 5) == 0) {
                                    // console.info('mark line', line);
                                    // return "rgba(0,0,0)";
                                    return markSubColor;
                                }

                                return false;
                            }
                        },
                        ticks: {
                            display: false,
                            stepSize: stepSize
                        },
                    },
                },
                responsive: false,
                maintainAspectRatio: false
            },
            plugins: [{
                afterDatasetDraw: (chart) => {
                    let ctx = chart.ctx;
                    ctx.font = parseInt(ctx.canvas.offsetHeight * 2 /100)+'px Arial';
                    ctx.textBaseline = 'bottom';
                    ctx.textAlign = 'left';
    
                    const hY = ctx.canvas.offsetHeight / ( this.maxY - this.minY );
            
                    chart.data.datasets.forEach((dataset, i) => {
                        let label = dataset.label.replace('data', '');

                        ctx.fillStyle = '#333'; // label color
                        ctx.fillText(label, label.length > 2 ? 32 : 36, ctx.canvas.offsetHeight - (this.getBaseYByType(dataset.label) - this.minY + 43 ) * hY);
                    });
                }
            }]
        });

        $(window).on('resize', () => {
            this.resizeContainer();
            this.chart.update();
        });
    }

    // get animation() {
    //     return {
    //         x: {
    //             type: 'number',
    //             easing: 'linear',
    //             duration: 1,
    //             from: NaN, // the point is initially skipped
    //             // from: (ctx) => {
    //             //     return ctx.index === 0 ? ctx.chart.scales.x.getPixelForValue(100) : !!ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1] ? ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1].getProps(['x'], true).x : 0;
    //             // },
    //             delay: function(ctx) {
    //                 if (ctx.type !== 'data' || ctx.xStarted) {
    //                     return 0;
    //                 }
    //                 ctx.xStarted = true;
    //                 return ctx.index * this.delayBetweenPoints;
    //             }
    //         },
    //         y: {
    //             type: 'number',
    //             easing: 'linear',
    //             duration: 1,
    //             from: (ctx) => {
    //                 return ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(100) : !!ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1] ? ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1].getProps(['y'], true).y : 0;
    //             },
    //             delay: function(ctx) {
    //                 if (ctx.type !== 'data' || ctx.yStarted) {
    //                     return 0;
    //                 }
    //                 ctx.yStarted = true;
    //                 return ctx.index * this.delayBetweenPoints;
    //             }
    //         },
    //         // onComplete: () => {
    //         //     console.debug('ANIMATION COMPLETE');
    //         //     this.scrollContainer();
    //         // }
    //     }
    //     // const animation = {
    //     //     xAxes: {
    //     //         type: 'number',
    //     //         easing: 'linear',
    //     //         duration: delayBetweenPoints,
    //     //         from: NaN, // the point is initially skipped
    //     //         delay(ctx) {
    //     //             if (ctx.type !== 'data' || ctx.xStarted) {
    //     //                 return 0;
    //     //             }
    //     //             ctx.xStarted = true;
    //     //             return ctx.index * this.delayBetweenPoints;
    //     //         }
    //     //     },
    //     //     yAxes: {
    //     //         type: 'number',
    //     //         easing: 'linear',
    //     //         duration: delayBetweenPoints,
    //     //         from: previousY,
    //     //         delay(ctx) {
    //     //             if (ctx.type !== 'data' || ctx.yStarted) {
    //     //                 return 0;
    //     //             }
    //     //             ctx.yStarted = true;
    //     //             return ctx.index * this.delayBetweenPoints;
    //     //         }
    //     //     }
    //     // };
    // }

    getSupportedTypes() {
        return [
            'dataD1',
            'dataD2',
            'dataD3',
            // dataV1 (vuoto)
            'dataV2',
            // dataV3 (vuoto)
            // dataV4 (vuoto)
            'dataV5',
            // dataV6 (vuoto)
            'dataAVF',
            'dataAVL',
            'dataAVR'
        ];
    }

    getBaseYByType(type) {
        switch(type) {
            case 'dataD1':
                return 28 * markGridY;
            case 'dataD2':
                return 24 * markGridY;
            case 'dataD3':
                return 20 * markGridY;
            case 'dataAVR':
                return 16 * markGridY;
            case 'dataAVL':
                return 12 * markGridY;
            case 'dataAVF':
                return 8 * markGridY;
            case 'dataV2':
                return 4 * markGridY;
            case 'dataV5':
                return 0;
            default:
                return -1;
        }
    }

    getIndexByType(type) {
        switch(type) {
            case 'dataD1':
                return 1;
            case 'dataD2':
                return 2;
            case 'dataD3':
                return 3;
            case 'dataAVR':
                return 4;
            case 'dataAVL':
                return 5;
            case 'dataAVF':
                return 6;
            case 'dataV2':
                return 7;
            case 'dataV5':
                return 8;
            default:
                return -1;
        }
    }

    checkNewData(newData, type) {
        let index = this.getIndexByType(type);

        const currentData = this.chart.data.datasets[index].data;

        if(currentData.length != newData.length) {
            // console.debug('CHECK LENGTH!!!');
            return true;
        }

        for(var i=0; i<currentData.length; i++) {
            if(currentData[i].x != newData[i].x || currentData[i].y != newData[i].y) {
                // console.debug('DIFFERENT DATA!!!', currentData[i], newData[i]);
                return true;
            }
        }

        return false;
    }

    convertData(data, type, mountain = true) {
        const baseY = this.getBaseYByType(type);
        let x = 0;
        var newData = [];

        if(mountain) {
            $(this.mountainArray).each(function(i, item) {
                newData.push({
                    x: item.x,
                    y: baseY + item.y
                });

                x = item.x;
            });
        }

        if(data.hasOwnProperty(type)) {
            $(data[type]).each(function(i, item) {
                if(i > 10000) {
                // if(i > 1500) {
                    return;
                }

                let y = baseY + ( item * mVRatio );

                if (y > this.maxY) {
                    y = this.maxY;
                }

                if(y < this.minY) {
                    y = this.minY;
                }

                // console.debug(i, item, x, y);
                newData.push({
                    x: x,
                    y: y
                });
    
                x += xRatio;
            });
        }

        // if(debug && newData.length > 2) {
        //     console.debug(newData.length, newData[newData.length - 2]);
        //     newData[newData.length - 2].y = this.minY;
        //     newData[newData.length - 1].y = this.maxY;
        // }

        return newData;
    }

    // setData(data) {
    //     if(debug) {
    //         console.debug('chart', this.chart, this.chart.scales);
    //     }

    //     // TODO: resize

    //     this.resizeContainer(data);

    //     if(data.length < parseInt($(this.container).width()/pointAspectRatio)) {
    //         if(debug) {
    //             console.debug('resetting max');
    //         }
    //         this.chart.config.options.scales.x.max = parseInt($(this.container).width()/pointAspectRatio);
    //     } else if(data.length >= this.chart.config.options.scales.x.max) {
    //         if(debug) {
    //             console.debug('updating max');
    //         }
    //         this.chart.config.options.scales.x.max = data.length + 20;
    //     }

    //     this.chart.update();

    //     $(this.getSupportedTypes).each(function(i, type) {
    //         const index = this.getIndexByType(type);
    //         let dataLv = this.convertData(data, type);

    //         if(debug) {
    //             console.debug('converted data', dataLv);
    //         }

    //         if(!this.checkNewData(dataLv, type)) {
    //             if(debug) {
    //                 console.debug('ignoring data. same array');
    //             }

    //             return;
    //         }

    //         this.chart.data.datasets[index].data = dataLv;
    //     });

    //     this.chart.update();

    //     setTimeout(() => {
    //         this.scrollContainer();
    //     }, 200);
    // }

    // addData(data) {
    //     if(debug) {
    //         console.debug('chart', this.chart, this.chart.scales);
    //     }
    //     var dataset = this.chart.data.datasets[1];
    //     var x;
    //     if(dataset.data.length > 0) {
    //         x = dataset.data[dataset.data.length - 1].x + 1;
    //     } else {
    //         x = this.chart.data.datasets[0].data[this.chart.data.datasets[0].data.length - 1].x;
    //     }
    //     $(data).each(function(i, item) {
    //         dataset.data.push({
    //             x: x,
    //             y: item
    //         });
    //         x += 1;
    //     });

    //     this.resizeContainer(dataset.data);
    //     this.scrollContainer();

    //     if(dataset.data.length >= this.chart.config.options.scales.x.max) {
    //         if(debug) {
    //             console.debug('updating max');
    //         }
    //         this.chart.config.options.scales.x.max = dataset.data.length + 20;
    //     }
        
    //     this.chart.update();
    // }

    resizeContainer(data = null) {
        if(!data) {
            data = this.chart.data.datasets[0].data;
        }

        const maxLimit = parseInt(data[data.length - 1].x);

        // console.log(max, maxLimit, parseInt($(this.container).width()/pointAspectRatio) + 1);

        if(maxLimit < parseInt($(this.container).parent().width()/pointAspectRatio)) {
            this.chart.config.options.scales.x.max = parseInt($(this.container).parent().width()/pointAspectRatio);
            if(debug) {
                console.debug('resetting by parent max', this.chart.config.options.scales.x.max);
            }
        } else if(maxLimit < parseInt($(this.container).width()/pointAspectRatio)) {
            this.chart.config.options.scales.x.max = parseInt($(this.container).width()/pointAspectRatio);
            if(debug) {
                console.debug('resetting by container max', this.chart.config.options.scales.x.max);
            }
        } else if(maxLimit >= this.chart.config.options.scales.x.max) {
            this.chart.config.options.scales.x.max = maxLimit;
            if(debug) {
                console.debug('updating max', this.chart.config.options.scales.x.max);
            }
        }

        // if(debug) {
        //     console.debug('resizing', data.length, data.length * xRatio * pointAspectRatio);
        // }
        // this.canvas.width = data.length * xRatio * pointAspectRatio;
        // $(this.container).css('width', data.length * xRatio * pointAspectRatio);

        let width = this.chart.config.options.scales.x.max * pointAspectRatio;

        // if(debug) {
        //     console.debug('resizing', data.length, width);
        // }

        this.canvas.width = width;
        $(this.canvas).css('width', width);
        $(this.container).css('width', width);
    }

    scrollContainer(scrollTimeout = 300) {
        if(debug) {
            console.debug('scrolling', $(this.container).width(), $(this.container).parent().width(), parseInt($(this.container).width() - $(this.container).parent().width()) + 1, scrollTimeout);
        }

        if(scrollTimeout = 0) {
            $(this.container).parent().stop().setScrollLeft(parseInt($(this.container).width() - $(this.container).parent().width()) + 1);
        } else {
            $(this.container).parent().stop().animate({
                scrollLeft: parseInt($(this.container).width() - $(this.container).parent().width()) + 1
            }, scrollTimeout);
        }
    }

    toBase64Image(type, quality) {
        return this.chart.toBase64Image(type, quality);
    }
}

window.ECGChart = ECGChart;